import classes from "./Main.module.scss";
import InvoiceData from "../../Flow/InvoiceData/InvoiceData";
import CreditCard from "../../Flow/Payment/CreditCard/CreditCard";
import { useSelector } from "react-redux";
import { useEffect,useState } from "react";
import Payment from "../../Flow/Payment/Payment";
import DescPix from "../../Flow/Payment/DescPix/DescPix";
import PixQrCode from "../../Flow/Payment/PixQrCode";
import PaymentError from "../../Flow/Payment/PaymentError/PaymentError";

const Main = () => {
  const payload = useSelector((state) => state.purchase);
  const [content,setContent] = useState(null);
  const [stateMain,setStateMain] = useState(null);
  const isBrazil = payload && payload.PostData && payload.PostData.invoice_info && payload.PostData.invoice_info.country === "Brasil";

  const FlowPayment = {
    InvoiceData: {
      title: "Dados da fatura",
      component: () => <InvoiceData />,
    },
    CreditCard: {
      title: "Pagamento",
      component: () => <CreditCard isBrazil={isBrazil} />,
    },
    DescPix: {
      title: "Pagamento",
      component: () => <DescPix />,
    },
    PixQrCode: {
      title: "Pagamento",
      component: () => <PixQrCode />,
    },
    PaymentError: {
      title: "Pagamento",
      component: () => <PaymentError />,
    },
  };
  useEffect(()=>{
    if(payload && payload.purchase && payload.purchase.step && payload.purchase.step !== stateMain){
      setStateMain(payload.purchase.step);
      setContent(FlowPayment[payload.purchase.step]);
    }
  },[payload.purchase,stateMain])

  return content && (
    <div className={classes.MainContent}>
      <div className={classes.MainTop}>
        {content.title}
      </div>
      <div className={classes.MainBottom}>
        {payload.purchase.step === "CreditCard" && <Payment />}
        {payload.purchase.step === "DescPix" && <Payment />}
        {content.component()}
      </div>
    </div>
  );
};
export default Main;
